import "./Button.scss";

import { Button as AppKitButton } from "@appkit4/react-components/button";
import type { ComponentProps, ReactNode } from "react";

export type ButtonVariant =
  | "primary"
  | "secondary"
  | "ghost"
  | "status-complete"
  | "status-delayed"
  | "status-at-risk"
  | "status-on-track";

type AppKitButtonProps = ComponentProps<typeof AppKitButton>;

export interface ButtonProps extends Omit<AppKitButtonProps, "kind" | "children"> {
  variant?: ButtonVariant;
  /** Left icon (e.g. ← or filter icon) */
  leftIcon?: ReactNode;
  /** Right icon (e.g. →) */
  rightIcon?: ReactNode;
  children: ReactNode;
}

export function Button({
  variant = "primary",
  leftIcon,
  rightIcon,
  children,
  className = "",
  type = "button",
  loading,
  ...props
}: ButtonProps) {
  const resolvedKind = (
    variant === "primary"
      ? "primary"
      : variant === "secondary"
        ? "secondary"
        : variant === "ghost"
          ? "text"
          : "secondary"
  ) satisfies AppKitButtonProps["kind"];
  const base = "shared-btn";
  const variantClass = `shared-btn--${variant}`;
  const classes = [base, variantClass, className].filter(Boolean).join(" ");

  return (
    <AppKitButton
      kind={resolvedKind}
      type={type}
      className={classes}
      {...(loading ? { loading: true } : {})}
      {...props}
    >
      <span className="shared-btn__content">
        {leftIcon && <span className="shared-btn__icon shared-btn__icon--left" aria-hidden>{leftIcon}</span>}
        <span className="shared-btn__label">{children}</span>
        {rightIcon && <span className="shared-btn__icon shared-btn__icon--right" aria-hidden>{rightIcon}</span>}
      </span>
    </AppKitButton>
  );
}
